import Box from "@mui/material/Box";
import {Title4} from "./Typography";
import * as React from "react";
import {exceptionsTitle} from "../../../dictionaries";
import {Typography} from "@mui/material";

const commonStyles = {
  bgcolor: 'background.paper',
  m: 1,
  p: 1,
  border: 1
};

/**
 *
 * @param {error: {errors: Array, message: string}} error
 * @constructor
 */
export const ErrorsListContainer = ({error}) => {
  return (
      <Box sx={{ ...commonStyles, borderColor: 'error.main' }}>
        <Title4 title={exceptionsTitle[error?.message] || error.message}></Title4>
        {error?.errors?.map((item)=>{
          return (<Typography variant="body2" gutterBottom>- {item?.message}</Typography>)
        })}
      </Box>
  )
}
